module.exports = __webpack_public_path__ + "static/media/user_login.50894019.svg";